import { styled } from '@mui/material';

import { removeTheseProps } from '@/utils';

import { RouterLink, type RouterLinkProps } from '.';

type SubMenuLinkProps = RouterLinkProps & {
  isActive: boolean;
};

export const SubMenuLink = styled(RouterLink, {
  shouldForwardProp: removeTheseProps<SubMenuLinkProps>('isActive'),
})<SubMenuLinkProps>(({ theme, isActive }) => ({
  height: 32,
  width: '100%',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 24,
  color: theme.palette.horizonText.main,
  fontSize: 12,
  transition: '200ms',
  boxShadow: isActive
    ? `-2px 0 0 ${theme.palette.horizonGreen.main} inset`
    : 'unset',
  backgroundColor: isActive ? theme.palette.horizonDisabled.main : 'unset',
  fontWeight: 600,
  ':hover': {
    backgroundColor: theme.palette.horizonDisabled.main,
    color: theme.palette.horizonText.main,
    fontWeight: 600,
  },
}));
